import { ResumenAtencion } from "../../bussines/entities/EstadisticasCRM.entity";

export class ResumenAtencionModel implements ResumenAtencion {
    constructor(
        public codProducto: string,
        public codResponsable: string,
        public codTipoAtencion: string,
        public mes: number,
        public nroAtenciones: number
    ) { }

    serialize(): ResumenAtencion {
        return {
            codProducto: this.codProducto,
            codResponsable: this.codResponsable,
            codTipoAtencion: this.codTipoAtencion,
            mes: this.mes,
            nroAtenciones: this.nroAtenciones
        }
    }

    static deserialize(entity: ResumenAtencion): ResumenAtencionModel {
        return new ResumenAtencionModel(
            entity.codProducto ?? '',
            entity.codResponsable ?? '',
            entity.codTipoAtencion ?? '',
            entity.mes ?? 0,
            entity.nroAtenciones ?? 0
        );
    }
}